/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Typography, Link, List, ListItem, Divider } from '@mui/material'
import { Helmet } from "react-helmet";
import MainLayout from '../../components/MainLayout'
import StaticPagesWrapper from '../../components/StaticPagesWrapper'
import ListItemHeader from '../../components/StaticPagesWrapper/ListItemHeader'

function Section({ title, children }) {
    const id = slugify(title);
    return (
        <Box component="section" id={id} sx={{ scrollMarginTop: 96 }}>
            <ListItemHeader>
                {title}
            </ListItemHeader>
            {children}
        </Box>
    );
}


function slugify(str) {
    return String(str)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quitar acentos
        .replace(/[^a-z0-9\s.-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
}

const CancelationPolicies = () => {

    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';

    if (lng == 'es') {
        return (
            <MainLayout>
                <Helmet>
                    <title>Política de Cancelación y Reembolso - ToursPrivados</title>
                    <meta
                        name="description"
                        content="Política General de Cancelación y Reembolso de Reservaciones de TREKZY"
                        data-react-helmet="true"
                    />
                </Helmet>

                <StaticPagesWrapper title="ToursPrivados">
                    <Box mb={8}>
                        <ListItemHeader styles={{ padding: 0 }}>
                            POLÍTICA GENERAL DE CANCELACIÓN Y REEMBOLSO DE RESERVACIONES
                        </ListItemHeader>

                        <Typography variant="body1" paragraph>
                            Si usted es (i) una persona física o persona moral; o (ii) una agencia de viajes o tours (<strong>“Agencia”</strong>) (<strong>“Usted”</strong>)
                            y ha realizado (por su propio derecho o en favor de terceras personas) una o más reservas de cualquier servicio
                            ofrecido a través del sitio web:{' '}
                            <Link href="https://trekzy.com" target="_blank" rel="noopener">
                                https://trekzy.com
                            </Link>{' '}
                            o{' '}
                            <Link href="https://toursprivados.com" target="_blank" rel="noopener">
                                https://toursprivados.com
                            </Link>{' '}
                            (<strong>“Sitio”</strong>) operado y/o propiedad de Tours Privados, S.L. (<strong>“TREKZY”</strong> según el destino del servicio contratado a través
                            del Sitio) Usted acepta expresamente sujetarse a esta Política General de Cancelación y Reembolso de Reservaciones
                            (la <strong>“Política”</strong>) una vez que la reserva de cualquier servicio contratado a través del Sitio ha sido confirmada por
                            TREKZY (una <strong>“Reserva Confirmada”</strong>) por lo que le pedimos leer de manera detenida esta Política previamente a realizar
                            cualquier transacción a través del Sitio.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Section title="CANCELACIONES Y MODIFICACIONES.">
                            <Typography variant="body1" paragraph>
                                Usted podrá solicitar a TREKZY, modificaciones, cancelaciones o especificaciones adicionales de su Reserva Confirmada
                                reconociendo que toda resolución a su solicitud de cancelación, modificación o especificaciones adicionales, dependerá
                                estrictamente de la disponibilidad del servicio que Usted haya contratado a través del Sitio por lo que TREKZY
                                establece como regla general un plazo de 48 (cuarenta y ocho) horas de anticipación como mínimo para que Usted tenga
                                derecho a que se le reembolse hasta el 100% (cien por ciento), salvo excepciones aplicando posibles restricciones las
                                cuales estarán debidamente descritas en el tour y/o será informado por el proveedor en su momento de confirmación
                                según la jurisdicción del servicio contratado.
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Ninguna solicitud de cancelación hecha con menos de 48 (cuarenta y ocho) horas previas a la fecha de la Reserva
                                    Confirmada será reembolsable.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Si el servicio (tour, traslado u otro) se ha reservado con un código promocional o con descuento especial aplicado,
                                    no procederá el reembolso al 100%, aun habiéndose cancelado el mismo en los tiempos estipulados. En estos casos, el
                                    porcentaje máximo de reembolso será de 80%.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Los descuentos especiales y/o códigos de promoción serán aplicables únicamente durante las fechas establecidas para
                                    el descuento en su Reserva Confirmada. Dichos descuentos no serán retroactivos en reservaciones realizadas en
                                    periodos anteriores a la promoción y/o en las que Usted omita ingresar el código de promoción en el campo
                                    correspondiente al momento de la reserva.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    En cancelaciones de Reservas Confirmadas motivadas con el fin de recibir un descuento publicado posterior a la compra
                                    original, se aplicará una penalización del 20% (veinte por ciento).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Los servicios especificados en una Reserva Confirmada constituyen la totalidad del mismo por lo que no habrá
                                    devoluciones parciales por servicios o consumos no realizados durante el mismo.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Para Reservas Confirmadas hechas a través de depósito parcial, en caso de cancelación, el depósito no es reembolsable.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Modificaciones de nombres no tienen costo (excepto en la compra de entradas nominales a atracciones que lo requieren).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Modificaciones de participantes a la alza tienen costo adicional por persona y sujetos a disponibilidad el día de la
                                    Reserva Confirmada.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="NO PRESENTACIÓN (NO SHOW).">
                            <Typography variant="body1" paragraph>
                                Si Usted, su(s) acompañante(s) o alguno de ellos/sus clientes simplemente no se presenta(n) al tour o servicio contratado
                                (no show) = No aplica ninguna clase de reembolso por ningún motivo y bajo ninguna circunstancia.
                            </Typography>
                        </Section>

                        <Section title="CASO FORTUITO/FUERZA:">
                            <Typography variant="body1" paragraph>
                                Esta Política no aplica en casos fortuitos o fuerza mayor como pueden ser huracán, puerto cerrado, trafico excesivo,
                                inundaciones, caminos enlodados o bloqueados, tormentas tropicales, epidemias, pandemias o cualquier otro fenómeno natural
                                o causado por el hombre y ajenos a TREKZY; para estos casos solamente se aplicará la política de cambio de fecha de su
                                Reserva Confirmada y caso por caso y a entera discreción de TREKZY podrá aplicar el reembolso total o parcial de la
                                Reserva Confirmada.
                            </Typography>
                        </Section>

                        <Section title="FORMA DE PAGO DEL REEMBOLSO.">
                            <Typography variant="body1" paragraph>
                                Si la Reserva Confirmada ha sido efectivamente cobrada por TREKZY le pediremos que nos indique la cuenta bancaría ligada a
                                la tarjeta asociada a su Reserva Confirmada para realizarle el reembolso de la misma.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Si la Reserva Confirmada no ha sido efectivamente cobrada por TREKZY realizaremos las gestiones necesarias para cancelar
                                el cargo de la Reserva Confirmada. Por favor tome en cuenta que el tiempo en que Usted verá reflejado el reembolso de los
                                fondos o la cancelación del cargo no depende de TREKZY, le sugerimos contactar al banco emisor de su tarjeta para mayor
                                información al respecto.
                            </Typography>
                        </Section>

                        <Section title="TÉRMINOS Y CONDICIONES DEL SITIO / PRIVACIDAD DE DATOS.">
                            <Typography variant="body1" paragraph>
                                Para información relacionada con los términos y condiciones del Sitio y como manejamos sus datos por favor refiérase a
                                los términos y condiciones y a la política de privacidad contenidos en el Sitio.
                            </Typography>
                        </Section>

                        <Section title="MODIFICACIONES Y ACTUALIZACIONES DE LA PRESENTE POLÍTICA.">
                            <Typography variant="body1" paragraph>
                                TREKZY podrá modificar, ampliar, corregir o actualizar la presente Política, en cualquier momento y su entera discreción.
                                En todos los casos, publicaremos en el Sitio la fecha de última actualización de esta Política.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                También podremos comunicar estos cambios a través del Sitio o mediante el envío de un correo electrónico a Usted en caso
                                de contar con su dirección pero sin estar obligado a ello.
                            </Typography>
                        </Section>

                        <Section title="CONTACTO.">
                            <Typography variant="body1" paragraph>
                                Para más información o asistencia, por favor contáctenos en el apartado de Contacto del Sitio.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />
                        <Typography variant="body2" color="text.secondary" paragraph>
                            Última actualización: 10 de agosto de 2024
                        </Typography>
                    </Box>
                </StaticPagesWrapper>
            </MainLayout>
        );
    }
    else {
        return (
            <MainLayout>
                <Helmet>
                    <title>General Reservation Cancellation and Refund Policy - TREKZY</title>
                    <meta
                        name="description"
                        content="General Reservation Cancellation and Refund Policy"
                        data-react-helmet="true"
                    />
                </Helmet>

                <StaticPagesWrapper title="Trekzy">
                    <Box mb={8}>
                        <ListItemHeader styles={{ padding: 0 }}>
                            GENERAL RESERVATION CANCELLATION AND REFUND POLICY
                        </ListItemHeader>

                        <Typography variant="body1" paragraph>
                            If you are (i) an individual or legal entity; or (ii) a travel or tour agency (&quot;Agency&quot;) (&quot;You&quot;) and have made
                            (on your own behalf or on behalf of third parties) one or more reservations for any service offered through the website:{' '}
                            <Link href="https://trekzy.com" target="_blank" rel="noopener">
                                https://trekzy.com
                            </Link>{' '}
                            or{' '}
                            <Link href="https://toursprivados.com" target="_blank" rel="noopener">
                                https://toursprivados.com
                            </Link>{' '}
                            (&quot;Site&quot;), operated and/or owned by Tours Privados, S.L. (&quot;TREKZY&quot; depending on the destination of the service contracted
                            through the Site), you expressly agree to be bound by this General Reservation Cancellation and Refund Policy (the &quot;Policy&quot;)
                            once the reservation for any service contracted through the Site has been confirmed by TREKZY (a &quot;Confirmed Reservation&quot;),
                            so we ask that you read this Policy carefully before making any transaction through the Site.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Section title="I. CANCELLATIONS AND MODIFICATIONS">
                            <Typography variant="body1" paragraph>
                                You may request TREKZY to modify, cancel, or specify additional information to your Confirmed Reservation. You acknowledge
                                that any resolution to your request for cancellation, modification, or additional information will depend strictly on the
                                availability of the service you have contracted through the Site. Therefore, TREKZY establishes, as a general rule, a minimum
                                notice period of 48 (forty-eight) hours for you to be entitled to a refund of up to 100% (one hundred percent). In certain cases,
                                restrictions may apply, which will be duly described in the tour and/or will be notified by the provider at the time of confirmation,
                                depending on the jurisdiction of the contracted service.
                            </Typography>

                            <List sx={{ listStyle: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item' }}>
                                    No cancellation request made less than 48 (forty-eight) hours prior to the Confirmed Reservation date will be refundable.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    If the service (tour, transfer, or other) was booked with a promotional code or a special discount applied, a full refund will not be
                                    issued, even if the cancellation was made within the stipulated timeframe. In these cases, the maximum refund percentage will be 80%.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Special discounts and/or promotional codes will only be applicable during the dates established for the discount in your Confirmed Reservation.
                                    These discounts will not be retroactive for reservations made prior to the promotion period and/or for reservations where you fail to enter the
                                    promotional code in the corresponding field at the time of booking.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    For cancellations of Confirmed Reservations motivated by the intention of receiving a discount published after the original purchase, a 20%
                                    (twenty percent) penalty will be applied.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    The services specified in a Confirmed Reservation constitute the entire reservation; therefore, there will be no partial refunds for services or
                                    purchases not made during that reservation.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    For Confirmed Reservations made through partial deposit, in the event of cancellation, the deposit is non-refundable.
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Name changes are free of charge (except for the purchase of nominal tickets to attractions that require it).
                                </ListItem>
                                <ListItem sx={{ display: 'list-item' }}>
                                    Increased participant changes have an additional cost per person and are subject to availability on the day of the Confirmed Reservation.
                                </ListItem>
                            </List>
                        </Section>

                        <Section title="II. NO SHOW.">
                            <Typography variant="body1" paragraph>
                                If you, your companion(s), or any of your clients simply fail to show up for the contracted tour or service (no show), no refund will apply for
                                any reason or under any circumstances.
                            </Typography>
                        </Section>

                        <Section title="III. FORTUITOUS EVENT/FORTUOUS EVENT:">
                            <Typography variant="body1" paragraph>
                                This Policy does not apply in cases of force majeure or unforeseen circumstances such as hurricanes, closed ports, excessive traffic, floods,
                                muddy or blocked roads, tropical storms, epidemics, pandemics, or any other natural or man-made phenomenon beyond the control of TREKZY.
                                In these cases, only the policy for changing the date of your Confirmed Reservation will apply, and on a case-by-case basis and at TREKZY&apos;s
                                sole discretion, a full or partial refund may be issued for the Confirmed Reservation.
                            </Typography>
                        </Section>

                        <Section title="IV. REFUND PAYMENT METHOD">
                            <Typography variant="body1" paragraph>
                                If the Confirmed Reservation has been charged by TREKZY, we will ask you to provide the bank account linked to the card associated with your
                                Confirmed Reservation in order to process the refund.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                If the Confirmed Reservation has not been charged by TREKZY, we will take the necessary steps to cancel the charge for the Confirmed Reservation.
                                Please note that the time it takes to receive a refund or cancellation of the charge does not depend on TREKZY. We suggest contacting your
                                card-issuing bank for more information.
                            </Typography>
                        </Section>

                        <Section title="V. SITE TERMS AND CONDITIONS / DATA PRIVACY.">
                            <Typography variant="body1" paragraph>
                                For information related to the terms and conditions of the Site and how we handle your data, please refer to the terms and conditions and privacy
                                policy contained on the Site.
                            </Typography>
                        </Section>

                        <Section title="VI. MODIFICATIONS AND UPDATES TO THIS POLICY.">
                            <Typography variant="body1" paragraph>
                                TREKZY may modify, expand, amend, or update this Policy at any time and at its sole discretion. In all cases, we will post the date this Policy was
                                last updated on the Site.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                We may also communicate these changes through the Site or by sending you an email if we have your email address, but we are not obligated to do so.
                            </Typography>
                        </Section>

                        <Section title="VI. CONTACT.">
                            <Typography variant="body1" paragraph>
                                For more information or assistance, please contact us in the Contact section of the Site.
                            </Typography>
                        </Section>

                        <Divider sx={{ my: 4 }} />
                        <Typography variant="body2" color="text.secondary" paragraph>
                            Last updated: August 10, 2024
                        </Typography>
                    </Box>
                </StaticPagesWrapper>
            </MainLayout>
        );
    }
}

export default CancelationPolicies
